import { parseFilename } from './files';
import axios from 'axios';
import { EXCEL_MERGER_BASE_URL } from '../constants';

export { downloadBlob } from './files';

export interface MergeOptions {
  copy_images?: boolean;
  preserve_formulas?: boolean;
  add_sumifs?: boolean;
  create_reference_sheet?: boolean;
  output_filename?: string;
}

export interface MergeResult {
  blob: Blob;
  filename: string;
  sheetCount: number | null;
}

export async function mergeExcelFiles(
  plFile: File,
  otherFiles: File[],
  options: MergeOptions = {}
): Promise<MergeResult> {
  const formData = new FormData();
  formData.append('pl_file', plFile);
  otherFiles.forEach((file) => formData.append('other_files', file));
  formData.append('options', JSON.stringify(options));

  try {
    const response = await axios.post(`${EXCEL_MERGER_BASE_URL}/excel-merger/merge`, formData, {
      responseType: 'blob',
    });

    const blob = response.data as Blob;
    const filename = parseFilename(
      response.headers['content-disposition'] || null,
      options.output_filename || 'Merged_Excel_Files.xlsx'
    );
    const sheetCountHeader = response.headers['x-sheet-count'];
    const sheetCount = sheetCountHeader ? Number(sheetCountHeader) : null;

    return { blob, filename, sheetCount };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const errorBlob = error.response?.data as Blob | undefined;
      const contentType = String(error.response?.headers?.['content-type'] || '');
      const data =
        errorBlob && contentType.includes('application/json')
          ? JSON.parse(await errorBlob.text())
          : null;
      const message = (data && data.detail) || `Merge failed with status ${error.response?.status}`;
      throw new Error(message);
    }
    throw error;
  }
}
